import type { QueryClient } from '@tanstack/react-query'
import type { GameResponse } from '@warcarp/api-types'

/** Refresh menu/lobby membership only when a game crosses a turn boundary. */
export function refreshTurnGames(qc: QueryClient, game: GameResponse): void {
  const listed = qc.getQueryData<GameResponse[]>(['games'])?.find((item) => item.id === game.id)
  if (!listed || listed.status !== game.status ||
    listed.currentPlayerIndex !== game.currentPlayerIndex || listed.currentTurn !== game.currentTurn) {
    void qc.invalidateQueries({ queryKey: ['games'], exact: true })
  }
}
